import { gql } from '@apollo/client';

export const getCheckoutHealthOfferGeneralTransferDetails = gql`
  query checkoutHealthOfferGeneralTransferDetails($offerId: String!, $installments: Int!) {
    health {
      checkoutHealthOfferGeneralTransferDetails(offerId: $offerId, installments: $installments) {
        price
        customerFirstName
        customerLastName
        customerAddress
        customerCity
        customerZipCode
        customerCountry
        customerPhone
        customerEmail
        customerOib
        recipientAccountNumber
        recipientAddress
        recipientCity
        recipientZipCode
        recipientName
        referenceNumberType
        referenceNumber
        referencePrefix
        referenceSuffix
        model
        description
        numberOfInstallments
      }
    }
  }
`;